import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Tag from '@groovehq/internal-design-system/lib/components/Tag/Tag'
import { selectCurrentSubmittedTicketSearchFilterMatches } from 'selectors/search/searchFilters'
import { selectCurrentCommittedTicketSearchQueryString } from 'selectors/search'
import { doClearSearch, doSubmitTicketsSearch } from 'actions/search'
import { selectCustomersByEmail } from 'ducks/customers/selectors'
import Button from '@groovehq/internal-design-system/lib/components/Button/Button'
import { propFunc } from 'util/functions'
import { styles } from '../styles'

const FilterBadges = () => {
  const dispatch = useDispatch()
  const currentCommittedTicketSearchQueryString = useSelector(
    selectCurrentCommittedTicketSearchQueryString
  )
  const matches = useSelector(selectCurrentSubmittedTicketSearchFilterMatches)
  const customersByEmail = useSelector(selectCustomersByEmail)

  const handleRemoveFilter = useCallback(
    filter => {
      const remainingSubmittedFilters = matches.filter(item => item !== filter)
      dispatch(
        doSubmitTicketsSearch(
          [
            ...remainingSubmittedFilters,
            currentCommittedTicketSearchQueryString,
          ]
            .filter(Boolean)
            .join(' '),

          { shouldIncludeMailboxSearch: true }
        )
      )
    },
    [dispatch, matches, currentCommittedTicketSearchQueryString]
  )

  const amendFilterBadge = useCallback(
    match => {
      const splitNameWithValue = match.split(':')
      const filterName = `${splitNameWithValue[0]}:`
      if (filterName !== 'from:') return match
      // Amend from: filter to include customer name
      const value = splitNameWithValue[1]
      const customer = customersByEmail[value]
      if (!customer?.name) return match
      return [splitNameWithValue[0], `${customer.name} (${value})`].join(':')
    },
    [customersByEmail]
  )

  const handleClear = useCallback(
    e => {
      dispatch(doClearSearch(e, { shouldBlur: true }))
    },
    [dispatch]
  )

  if (!matches.length) return null

  return (
    <div
      className="grui p-5 pl-8 flex flex-wrap items-center"
      css={styles.filterBadges}
    >
      <Button size="small" type="secondary" onClick={handleClear}>
        Clear search filters
      </Button>
      {matches.map((match, index) => (
        <Tag
          closable
          css={styles.filterBadge}
          key={match}
          onClose={propFunc(handleRemoveFilter, match, index)}
        >
          {amendFilterBadge(match)}
        </Tag>
      ))}
    </div>
  )
}

export default FilterBadges
